import React, { type FC, useEffect, memo } from 'react';
import {
  useEnvironment,
  type IHostProps,
  type WidgetProps,
} from '@wix/yoshi-flow-editor';
import { flowRight } from 'lodash';
import { useSettings } from '@wix/tpa-settings/react';
import { type AdUnit } from '@wix/ambassador-adsense-v1-adsense-adunit/types';
import { type ConnectStatus } from '@wix/ambassador-adsense-v1-adsense-user/types';
import withWidgetProviders from '@app/hoc/with-widget-providers';
import { useWidgetDispatch } from '@app/hooks/redux-hooks';
import settingsParams from '@app/settingsParams';
import {
  setAdUnit,
  setConnectStatus,
} from '@app/store/widget/slices/widget-slice';
import EditorContent from './editor/editor-content';
import LiveSiteContent from './live-site/live-site-content';

export interface ControllerProps {
  connectStatus: ConnectStatus;
  adUnitByCompId?: AdUnit;
  isMobile: boolean;
}

const Widget: FC<WidgetProps<ControllerProps>> = memo((props) => {
  const settings = useSettings();
  const { isViewer } = useEnvironment();
  const { connectStatus, adUnitByCompId } = props;
  const selectedAdUnit = settings.get(settingsParams.selectedAdUnit);

  const dispatch = useWidgetDispatch();

  useEffect(() => {
    dispatch(setConnectStatus(connectStatus));
    dispatch(setAdUnit(adUnitByCompId));
  }, [dispatch, connectStatus, adUnitByCompId]);

  useEffect(() => {
    if (selectedAdUnit?.reportingDimensionId) {
      dispatch(setAdUnit(selectedAdUnit));
    }
  }, [dispatch, selectedAdUnit]);

  if (isViewer) {
    return <LiveSiteContent />;
  }
  return <EditorContent />;
});

export default flowRight(withWidgetProviders(Widget));
